import React, { useEffect } from 'react';
import { useStateMachine } from 'little-state-machine';
import updateAction from './updateAction';
import { userTypeOptions } from '../../utils/const';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useForm } from 'react-hook-form';
import { getProfileDetails } from '../../redux/profile/profile.actions';
import Card from 'react-bootstrap/Card';

const Step1 = ({ history, userType, getProfileDetails }) => {
	const { register, handleSubmit, errors } = useForm();
	const { action, state } = useStateMachine(updateAction);

	useEffect(() => {
		getProfileDetails();
	}, [getProfileDetails]);

	const onSubmit = (data) => {
		action(data);
		history.push('/onboard/step2');
	};

	const getSelectOptionsList = (options) => {
		let result = [];
		!!options &&
			options.map(function (val, index) {
				result.push(
					<div key={index} className="funkyradio-success">
						<input
							type="radio"
							name="userType"
							value={val}
							ref={register({
								required: true,
							})}
							id={val}
							defaultChecked={val === (state?.data?.userType || userType)}
						/>
						<label for={val}>{val}</label>
					</div>,
				);
				return true;
			});
		return result;
	};

	return (
		<Card>
			<Card.Header className="setup-content" id="step-1">
				<h3 className="">What is your background?</h3>
			</Card.Header>
			<Card.Body>
				<form onSubmit={handleSubmit(onSubmit)}>
					<span className="profileError">
						{errors.userType?.type === 'required' && 'Your background is required'}
					</span>
					<div className="funkyradio">{getSelectOptionsList(userTypeOptions)}</div>
					<button
						aria-label="next"
						className="btn btn-primary nextBtn pull-right"
						type="submit"
					>
						Next
					</button>
				</form>
			</Card.Body>
		</Card>
	);
};

const mapStateToProps = (state) => {
	const { userType, userTypeOther } = state.rootReducer.profileDetails;
	return {
		userType,
		userTypeOther,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getProfileDetails: () => dispatch(getProfileDetails()),
	};
};

export default compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps),
)(Step1);
